const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

export function isSafeAppRelativePath(path) {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) return false;
  return !/^https?:/i.test(path);
}

export function setPostLoginRedirect(path) {
  if (isSafeAppRelativePath(path)) {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
  }
}

export function clearPostLoginRedirect() {
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
}

export function resolvePostLoginRedirect(location) {
  const fromState = location?.state && typeof location.state === "object" ? location.state.from : null;
  const fromQuery = new URLSearchParams(location?.search || "").get("returnTo");
  const fromStorage = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  return [fromState, fromQuery, fromStorage].find(isSafeAppRelativePath) || null;
}

export function buildLoginPath(returnTo = "/home") {
  const safeReturnTo = isSafeAppRelativePath(returnTo) ? returnTo : "/home";
  return `/login?returnTo=${encodeURIComponent(safeReturnTo)}`;
}
